import { createContext, useContext, useMemo } from 'react';

const FiltersContext = createContext();

export const FiltersProvider = ({
  children,
  filters,
  config,
  resetFilters,
  locationInputRef,
}) => {
  const value = useMemo(
    () => ({
      filters,
      config,
      resetFilters,
      locationInputRef,
    }),
    [filters, config, resetFilters, locationInputRef],
  );

  return (
    <FiltersContext.Provider value={value}>{children}</FiltersContext.Provider>
  );
};

export const useFiltersContext = () => useContext(FiltersContext);

export const withFiltersContext = (Component) => (props) => {
  const contextValue = useFiltersContext();

  return <Component {...contextValue} {...props} />;
};

export default FiltersContext;
